import { CUSTOMER_TABLE, CUSTOMER_PARTNER_TABLE } from './type'
import * as tableAction from '../../../table/state/action'
import { selectOwnState, tableSelectorEmployee } from './selector'


export const initialTableQueryEmployee = tableAction.createInitialTableQueryAction(selectOwnState, CUSTOMER_TABLE)

export const changeFilterEmployee = tableAction.createChangeFilterAction(selectOwnState, CUSTOMER_TABLE)

export const toggleSortEmployee = tableAction.createToggleSortAction(selectOwnState, CUSTOMER_TABLE)

export const toggleMultiSortEmployee = tableAction.createToggleMultiSortAction(selectOwnState, CUSTOMER_TABLE)

export const gotoPageEmployee = tableAction.createGotoPageAction(CUSTOMER_TABLE)


export const initialTableQueryPartner = tableAction.createInitialTableQueryAction(selectOwnState, CUSTOMER_PARTNER_TABLE)

export const changeFilterPartner = tableAction.createChangeFilterAction(selectOwnState, CUSTOMER_PARTNER_TABLE)

export const toggleSortPartner = tableAction.createToggleSortAction(selectOwnState, CUSTOMER_PARTNER_TABLE)

export const toggleMultiSortPartner = tableAction.createToggleMultiSortAction(selectOwnState, CUSTOMER_PARTNER_TABLE)

export const gotoPagePartner = tableAction.createGotoPageAction(CUSTOMER_PARTNER_TABLE)

export const initialTableSettings = tableAction.createInitialColumnsVisibilityTableHandler(CUSTOMER_TABLE)

export const toggleColumnVisibility = tableAction.createToggleColumnVisibilityTableHandler(tableSelectorEmployee, CUSTOMER_TABLE)





// WEBPACK FOOTER //
// ./src/modules/customer/state/search/action.js